import React, { useCallback } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

import {
  CREDIT_ADDITION_REASON_OPTIONS,
  CREDIT_DEDUCTION_REASON_OPTIONS,
  otherReasonInputSelector,
  reasonSelector,
  setFieldErrors,
  setOtherReasonInput,
  setReason,
  transactionTypeSelector,
} from 'features/creditManagement';
import Field from 'components/Field';
import Select from 'components/Select';
import styles from './ManageCreditReasonField.module.scss';

function ManageCreditReasonField() {
  const dispatch = useDispatch();

  const reason = useSelector(reasonSelector);
  const valueType = useSelector(transactionTypeSelector);
  const reasonInput = useSelector(otherReasonInputSelector);

  const handleReasonChange = useCallback(
    (option) => {
      batch(() => {
        dispatch(setFieldErrors(null));
        dispatch(setReason(option));
        dispatch(setOtherReasonInput(''));
      });
    },
    [dispatch]
  );

  const handleCustomReasonChange = useCallback(
    (e) => {
      dispatch(setOtherReasonInput(e.target.value));
    },
    [dispatch]
  );

  return (
    <Field
      label={`Select Reason to ${
        valueType === 'ADD' ? 'Add' : 'Deduct'
      } Credit:`}
      className={styles.inputHeader}
      name="addCreditCountField"
      prefixName="addCreditCountField"
    >
      <Select
        className={styles.selectReason}
        placeholder="Select reason"
        options={
          valueType === 'ADD'
            ? CREDIT_ADDITION_REASON_OPTIONS
            : CREDIT_DEDUCTION_REASON_OPTIONS
        }
        value={reason}
        onChange={handleReasonChange}
        menuPlacement="auto"
      />
      {reason?.tag === 'other' && (
        <textarea
          className={classNames(styles.entityInput, 'p-b-xxs')}
          onChange={handleCustomReasonChange}
          value={reasonInput}
          placeholder={'Please Give Reason to add Credit'}
        />
      )}
    </Field>
  );
}

export default ManageCreditReasonField;
